<div class="main_content px-3 position-relative">
    <div class="container py-3">
        <div class="title mb-4">
            <h2>REVIEW INFORMATION</h2>
        </div>
        <div class="white_box shadow p-3">
            <div class="row">
                <div class="col-md-4">
                    <select class="form-control" (change)="onChangeUrl($event)">
                        <option value="" selected disabled>Select URL</option>
                        <option *ngFor="let i of url_names" value="{{i.url_name}}">{{i.url_name}}</option>
                    </select>
                </div>
                <div class="col-md-2 offset-md-4">
                    <select class="form-control" (change)="onChangeMonth($event)" [(ngModel)]="selectedMonth">
                        <option value="" selected disabled>Month</option>
                        <option *ngFor="let i of month" value="{{i.id}}">{{i.name}}</option>
                    </select>
                </div>
                <div class="col-md-2">
                    <select class="form-control" (change)="onChangeYear($event)" [(ngModel)]="selectedYear">
                        <option value="" selected disabled>Year</option>
                        <option *ngFor="let i of years" value="{{i.name}}">{{i.name}}</option>
                    </select>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-4">
                    <div class="static_analytics outlets">
                        <div class="analytic_scoree">
                            <nz-progress [nzPercent]="review_count_rank" [nzSuccessPercent]="null" [nzSteps]="5"
                                nzStrokeColor="#354559"></nz-progress>
                        </div>
                        <h6>Total Reviews</h6>
                        <p>{{review_count}} reviews</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="static_analytics outlets">
                        <div class="analytic_scoree">
                            <nz-progress [nzPercent]="review_count_five_rank" [nzSuccessPercent]="null" [nzSteps]="5"
                                nzStrokeColor="#354559"></nz-progress>
                        </div>
                        <h6>Total Reviews <span>(5 stars)</span></h6>
                        <p>{{review_count_five}} reviews</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="static_analytics outlets">
                        <div class="analytic_scoree">
                            <nz-progress [nzPercent]="review_count_less_equal_four_rank" [nzSuccessPercent]="null"
                                [nzSteps]="5" nzStrokeColor="#354559"></nz-progress>
                        </div>
                        <h6>Total Reviews <span>(< 4 stars)</span>
                        </h6>
                        <p>{{review_count_less_equal_four}} reviews</p>
                    </div>
                </div>
            </div>
            <h5 class="dash_subheading mt-4 mb-2">Staff</h5>
            <div class="row">
                <div class="col-md-7">
                    <select class="form-control mb-2" (change)="onChangeStaff($event)">
                        <option value="" [selected]="!staffSelected" disabled>Select Staff Name</option>
                        <option *ngFor="let i of staffs" value="{{i.id}}">{{i.urlName}} - {{i.name}}</option>
                    </select>
                    <h6 class="rev_subheading">Review</h6>
                    <div class="key_stats">
                        <div class="key_secure">
                            <div class="key_stats_det">

                                <owl-carousel-o [options]="customOptions">
                                    <ng-container *ngFor="let slide of reviews_all">
                                        <ng-template carouselSlide>
                                            <div class="row">
                                                <div class="col-md-6 mb-2"
                                                    *ngFor="let subslide of slide; let i = index;">
                                                    <div class="card rounded-lg border-0 h-100">
                                                        <div class="card-body">
                                                            <span style="color: #354559 !important">
                                                                <ul class="lilist">
                                                                    <li *ngFor="let star of stars; let i = index">
                                                                        <i class="fa" [ngClass]="{
                                                              'fa-star': subslide.star >= i + 1,
                                                              'fa-star-half': subslide.star >= i + 0.5 && subslide.star < i + 1
                                                            }" aria-hidden="true"></i>
                                                                    </li>
                                                                </ul>
                                                            </span>
                                                            <p class="fdbk_cr">{{ subslide.created * 1000 | date:
                                                                'medium' }}
                                                            </p>
                                                            <hr>
                                                            @if(subslide.description) {

                                                            <p>{{ subslide.description || 'No Description' }}</p>
                                                            } @else {
                                                            <p style="color: #a3a4a4 !important;">No Comment</p>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </ng-container>
                                </owl-carousel-o>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <!-- <owl-carousel-o [options]="customOptions"> -->
                    <div class="d-fledx">
                        <div class="static_analytics">
                            <div class="analytic_scoree">
                                <nz-progress [nzPercent]="review_count_five_rank_below" [nzSuccessPercent]="null"
                                    [nzSteps]="5" nzStrokeColor="#354559"></nz-progress>
                            </div>
                            <h6>No. of 5 Star</h6>
                            <p>{{ review_count_five_below }} reviews</p>
                        </div>
                        <div class="static_analytics">
                            <div class="analytic_scoree">
                                <nz-progress [nzPercent]="review_count_four_rank" [nzSuccessPercent]="null"
                                    [nzSteps]="5" nzStrokeColor="#354559"></nz-progress>
                            </div>
                            <h6>No. of 4 Star</h6>
                            <p>{{review_count_four}} reviews</p>
                        </div>
                        <div class="static_analytics">
                            <div class="analytic_scoree">
                                <nz-progress [nzPercent]="review_count_three_rank" [nzSuccessPercent]="null"
                                    [nzSteps]="5" nzStrokeColor="#354559"></nz-progress>
                            </div>
                            <h6>No. of 3 Star</h6>
                            <p>{{review_count_three}} reviews</p>
                        </div>
                        <div class="static_analytics">
                            <div class="analytic_scoree">
                                <nz-progress [nzPercent]="review_count_two_rank" [nzSuccessPercent]="null" [nzSteps]="5"
                                    nzStrokeColor="#354559"></nz-progress>
                            </div>
                            <h6>No. of 2 Star</h6>
                            <p>{{review_count_two}} reviews</p>
                        </div>
                        <div class="static_analytics">
                            <div class="analytic_scoree">
                                <nz-progress [nzPercent]="review_count_one_rank" [nzSuccessPercent]="null" [nzSteps]="5"
                                    nzStrokeColor="#354559"></nz-progress>
                            </div>
                            <h6>No. of 1 Star</h6>
                            <p>{{review_count_one}} reviews</p>
                        </div>
                    </div>
                    <ng-template>
                        <div class="item block1">

                        </div>
                    </ng-template>
                    <ng-template>
                        <div class="item block2">
                        </div>
                    </ng-template>
                    <!-- </owl-carousel-o> -->
                </div>
            </div>
        </div>
    </div>
</div>